import * as Yup from "yup";

const subfamiliaProdutosValidator = Yup.object().shape({
  ativado: Yup.boolean().nullable(),
  descricao: Yup.string().required("Descrição"),
});

export default subfamiliaProdutosValidator;
